<template>
  <div class="config_main_manage_background">
    <!-- 设置页面的内容区域 -->
    <div class="config_main_manage_page_wraper">
      <div class="config_main_manage_page_content">
        <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->
        <config-title-hang class="config_hight_change_device_details">
          <span slot="config_title_hang_ele4">右击可删除一个定时任务</span>
          <img
            slot="config_title_hang_ele3"
            src="~assets/img/config/tishilaba.png"
            alt
          />
        </config-title-hang>

        <config-title-hang>
          <span slot="config_title_hang_ele2">{{
            ServeOneObjectinfo.remark
          }}</span>
        </config-title-hang>

        <config-hang @click.native="addCycleTask027BtnHandle">
          <span slot="config_hang_ele2">添加一个周期定时任务</span>
          <img
            slot="config_hang_ele4"
            src="~assets/img/config/youjiantou.png"
            alt
          />
        </config-hang>

        <config-title-hang>
          <span slot="config_title_hang_ele2">已有的定时任务列表</span>
        </config-title-hang>

        <config-hang
          @click.native="changeOneCycleTaskBtnHandle(value)"
          @contextmenu.prevent.native="OneCycleTaskRightClickBtnHandle(index)"
          v-for="(value, index) in serveCycleTaskData"
          :key="index"
          :switchState="Number(value.taskStatus)"
        >
          <span slot="config_hang_ele2">定时{{ index + 1 }}</span>
          <!-- <span slot="config_hang_ele_cycle_zhouqi">重复：每天</span> -->
          <span slot="config_hang_ele_cycle_zhouqi"
            >重复：{{ showCycleTimeComputer(value.weeks) }}</span
          >
          <span slot="config_hang_ele_cycle_timing"
            >定时时间：{{ value.openTime }}(开)-{{ value.closeTime }}(关)</span
          >

          <img
            slot="config_hang_switchBtn_open"
            src="~assets/img/config/zhu_kai.png"
            alt
          />
          <img
            slot="config_hang_switchBtn_close"
            src="~assets/img/config/zhu_guan.png"
            alt
          />
          <!-- 虚拟一个按钮的点击背景 -->
          <div
            @click.stop="cycle027SwitchBtnHandle(value)"
            class="click_background_btn"
          ></div>
        </config-hang>

        <div class="public_config_que_ren_btn" @click="saveReturnBtnHandle">
          保存并返回
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import topNav from 'components/common/topnav/topnav'
import topNavItem from 'components/common/topnav/topnavitem'
import configHang from 'components/common/config/config-hang'
import configTitleHang from 'components/common/config/config-title-hang'
// import { mediumslateblue } from "color-name";
import { configPageDataRequest } from 'views/afterLogin/config/deviceManagePage/deviceListPage/public_config_requery_js'

export default {
  data() {
    return {
      ServeOneObjectinfo: {
        ////地址指向仓库  当前要进行设置对象的信息
      },
      serveCycleTaskData: [
        ////周期任务已有的定时列表
      ],
      serveOneCycTask027Data: {
        /////一个周期定时任务的数据
        closeTime: '',
        createTime: '',
        cycleId: '',
        deviceId: '',
        openTime: '',
        // taskId: 1,
        taskStatus: 1,
        weeks: ''
      }
    }
  },
  computed: {},
  components: {
    topNav,
    topNavItem,
    configHang,
    configTitleHang
  },
  methods: {
    saveReturnBtnHandle() {
      ///保存并返回按钮点击了
      // this.ServeOneObjectinfo.businessId3 = this.selectObjectID;
      this.$router.go(-1)
    },
    addCycleTask027BtnHandle() {
      ///添加一个周期定时任务  被点击了

      this.$store.dispatch(
        'asyUpdataserveOneCycTask027Data',
        this.serveOneCycTask027Data
      ) ///异步提交一个定时任务信息到仓库

      this.$router.push('addCycTask027Page')
    },
    cycle027SwitchBtnHandle(value) {
      console.log('1111111333')
      ///打开定时和关闭定时的按钮按下了
      if (value.taskStatus === 1) {
        value.taskStatus = 0
      } else {
        value.taskStatus = 1
      }
      // 未完成的工作   这里还需要接口请求

      ////插座修改插座周期定时任务  接口
      this.$request({
        method: 'post',
        url: '/device/updateCycleTimeById',
        data: {
          token: this.$store.state.token,
          cycleId: value.cycleId,
          weeks: value.weeks,
          taskStatus: value.taskStatus,
          openTime: value.openTime,
          closeTime: value.closeTime
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            ////控制失败了，把状态修改回去
            if (value.taskStatus === 1) {
              value.taskStatus = 0
            } else {
              value.taskStatus = 1
            }

            this.$showTipsToast(3, res.data.message)
            ////说明信息填写错误,控制失败了，
            return
          } else {
            ////、控制成功了
            // this.serveCycleTaskData = res.data.data ////拿到服务器返回的数据结果
            console.log(res.data.data)
            // this.$showTipsToast(1, "获取成功", true); ////提示框
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    changeOneCycleTaskBtnHandle(value) {
      this.$store.dispatch('asyUpdataserveOneCycTask027Data', value) ///异步提交一个定时任务信息到仓库

      this.$router.push('addCycTask027Page')
    },
    showCycleTimeComputer(value) {
      let cycleShow = ''
      let count = 0
      if (value.indexOf('1') != -1) {
        cycleShow += '周一 '
        count++
      }
      if (value.indexOf('2') != -1) {
        cycleShow += '周二 '
        count++
      }
      if (value.indexOf('3') != -1) {
        cycleShow += '周三 '
        count++
      }
      if (value.indexOf('4') != -1) {
        cycleShow += '周四 '
        count++
      }
      if (value.indexOf('5') != -1) {
        cycleShow += '周五 '
        count++
      }
      if (value.indexOf('6') != -1) {
        cycleShow += '周六 '
        count++
      }
      if (value.indexOf('7') != -1) {
        cycleShow += '周日 '
        count++
      }
      if (count >= 7) {
        cycleShow = '每天'
      }
      return cycleShow
    },
    OneCycleTaskRightClickBtnHandle(index) {
      this.$showTipsToast(15, this.serveCycleTaskData, false, 1000, index)
    }
  },
  created() {
    console.log('created阶段')
    this.ServeOneObjectinfo = this.$store.state.configinfo.ServeOneObjectinfo ////一个对象的地址信息拿过来
    console.log(this.ServeOneObjectinfo)
    this.serveOneCycTask027Data.deviceId = this.ServeOneObjectinfo.deviceId
    ////获取插座周期定时列表  接口
    this.$request({
      method: 'post',
      url: '/device/findCycleTimeByDeviceId',
      data: {
        token: this.$store.state.token,
        deviceId: this.ServeOneObjectinfo.deviceId
      }
    })
      .then(res => {
        if (res.data.code != 0) {
          this.$showTipsToast(3, res.data.message)
          ////说明信息填写错误,控制失败了，
          return
        } else {
          ////、控制成功了
          this.serveCycleTaskData = res.data.data ////拿到服务器返回的数据结果
          console.log(this.serveCycleTaskData)
          // this.$showTipsToast(1, "获取成功", true); ////提示框
        }
      })
      .catch(error => {
        console.log(error)
      })
  }
}
</script>

<style>
div .config_hight_change_device_details {
  height: 40px;
  line-height: 40px;
  margin-bottom: 8px;
}
div .config_hight_change_device_details img {
  right: 210px;
  top: 13px;
}
.click_background_btn {
  width: 100px;
  height: 60px;
  background: transparent;

  position: absolute;
  right: 0px;

  z-index: 6;
}
</style>
